<script setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { useThemeSetting } from "@/Composable/ThemeSetting";

const { isDark } = useThemeSetting();
const page = usePage();
const authProviders = [
  {
    icon: "mdi-facebook",
    name: "facebook",
    color: "#4267b2",
    colorInDark: "#4267b2",
    enable:
      page.props.setting.facebookLogin.enable == "true" ||
      page.props.setting.facebookLogin.enable == true,
  },
  {
    icon: "mdi-twitter",
    name: "twitter",
    color: "#1da1f2",
    colorInDark: "#1da1f2",
    enable:
      page.props.setting.twitterLogin.enable == "true" ||
      page.props.setting.twitterLogin.enable == true,
  },
  {
    icon: "mdi-github",
    name: "github",
    color: "#272727",
    colorInDark: "#fff",
    enable:
      page.props.setting.githubLogin.enable == "true" ||
      page.props.setting.githubLogin.enable == true,
  },
  {
    icon: "mdi-google",
    name: "google",
    color: "#db4437",
    colorInDark: "#db4437",
    enable:
      page.props.setting.googleLogin.enable == "true" ||
      page.props.setting.googleLogin.enable == true,
  },
];

// const listAuthProviders = computed(() => authProviders.filter(e => e.enable))
</script>

<template>
  <span v-if="is_enabled_module('loginSocial')" class="mx-2 flex gap-3">
    <a
      v-for="link in authProviders.filter((e) => e.enable)"
      :key="link.icon"
      :href="route('social.login', link.name)"
    >
      <VBtn :icon="link.icon" variant="outlined" :color="link.color" />
    </a>
  </span>
</template>
